module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( transaction_date ))==null?'':_.escape(__t))+
'</td>\n<td>\n  ';
 if (payment_item.costcentre) { 
__p+='\n    '+
((__t=( payment_item.costcentre.code ))==null?'':_.escape(__t))+
'\n    '+
((__t=( payment_item.costcentre.name ))==null?'':_.escape(__t))+
'\n  ';
 } 
__p+='\n</td>\n<td>\n  ';
 if (bank_account) { 
__p+='\n    '+
((__t=( bank_account.name ))==null?'':_.escape(__t))+
'\n  ';
 } 
__p+='\n</td>\n<td>\n  ';
 if (contact) { 
__p+=' \n    '+
((__t=( contact.last_name ))==null?'':_.escape(__t))+
', '+
((__t=( contact.first_name ))==null?'':_.escape(__t))+
'\n  ';
 } 
__p+='\n</td>\n<td>\n  ';
 if (contact_first_name && contact_last_name) { 
__p+='\n    '+
((__t=( contact_last_name ))==null?'':_.escape(__t))+
', '+
((__t=( contact_first_name ))==null?'':_.escape(__t))+
'\n  ';
 } 
__p+='\n</td>\n<td>'+
((__t=( description ))==null?'':_.escape(__t))+
'</td>\n<td class="amount">'+
((__t=( amount ))==null?'':_.escape(__t))+
'</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment/templates/transaction/row.html
// module id = 340
// module chunks = 0